/**
 * Whether a field's title carries a mark for being required, for being
 * optional, both or neither.
 *
 * A document can say for itself (`content.marks`); what it leaves unsaid
 * falls to the host's defaults. A filled form marks the few optional
 * questions and leaves required ones unmarked, since most are required;
 * an element type's configuration form marks nothing, since its fields
 * are settings rather than questions. A per-form setting the designer
 * chooses will sit on top of this later.
 */

export interface FieldMarks {
  showRequiredMark?: boolean;
  showOptionalMark?: boolean;
}

export interface ResolvedFieldMarks {
  showRequiredMark: boolean;
  showOptionalMark: boolean;
}

/** Defaults for a form a filler answers. */
export const FORM_FIELD_MARKS: ResolvedFieldMarks = {
  showRequiredMark: false,
  showOptionalMark: true,
};

/** Defaults for an element type's configuration form in the designer. */
export const CONFIG_FORM_FIELD_MARKS: ResolvedFieldMarks = {
  showRequiredMark: false,
  showOptionalMark: false,
};

export function resolveFieldMarks(
  content: { marks?: FieldMarks | null } | null | undefined,
  defaults: ResolvedFieldMarks = FORM_FIELD_MARKS,
): ResolvedFieldMarks {
  const own = content?.marks ?? {};
  return {
    showRequiredMark:
      typeof own.showRequiredMark === "boolean" ? own.showRequiredMark : defaults.showRequiredMark,
    showOptionalMark:
      typeof own.showOptionalMark === "boolean" ? own.showOptionalMark : defaults.showOptionalMark,
  };
}
